export const alertsHeader = [
	{
		width: 140,
		title: 'Plant Name',
		field: 'plant_name',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 200,
		title: 'Part No',
		field: 'part_number',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 500,
		title: 'Alert Description',
		field: 'alert_description',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 160,
		title: 'Raised At',
		field: 'created_at',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 200,
		title: 'Raised By',
		field: 'created_by',
		enableSearch: true,
		enableFilter: true,
	},
];
